<template>
  <div id="center" class="ml-1 mt-1 bg-color-black">
    <el-tag class="coreTitle mt-1 pb-1">NU指标</el-tag>
    <div style="display: flex">
      <div class="up">
        <div
            class="item"
            v-for="item in titleItem"
            :key="item.title"
        >
          <div class="titleDiv">
            <el-tag class="tileSize" style="background-color: transparent;border: none;color: white;text-align: center;">{{ item.title }}</el-tag>
          </div>
          <div>
            <div class="dv-dig-flop">{{ item.number.number + item.number.content }}</div>
          </div>
        </div>
      </div>
      <div class="down">
        <div ref="chartContainer" style="height: 100%;"></div>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companyCore",
  mixins: [autoResize],
  props: [],
  data() {
    return {
      titleItem: [
        {
          title: '总注册人数',
          number: {
            number: 35126,
            toFixed: 1,
            textAlign: 'center',
            content: '人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '30日注册人数',
          number: {
            number: 1784,
            toFixed: 0,
            textAlign: 'center',
            content: '人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '7日注册人数',
          number: {
            number: 332,
            toFixed: 1,
            textAlign: 'center',
            content: '人',
            style: {
              fontSize: 26
            }
          }
        },
      ],
      ranking: {
        data: []
      },
      rankingOp : {
        carousel: 'single',
        unit: 'ppm',
        waitTime: 15000
      },
      water: {
        data: [10, 50],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 4
      },
      // 通过率和达标率的组件复用数据
      rate: [
        {
          id: 'centerRate1',
          tips: 60,
          colorData: {
            textStyle: '#3fc0fb',
            series: {
              color: ['#00bcd44a', 'transparent'],
              dataColor: {
                normal: '#03a9f4',
                shadowColor: '#97e2f5'
              }
            }
          }
        },
        {
          id: 'centerRate2',
          tips: 40,
          colorData: {
            textStyle: '#67e0e3',
            series: {
              color: ['#faf3a378', 'transparent'],
              dataColor: {
                normal: '#ff9800',
                shadowColor: '#fcebad'
              }
            }
          }
        }
      ]
    }
  },
  watch: {

  },
  components: {
  },
  methods: {
    renderChart() {
      const dom = this.$refs.chartContainer;
      this.myChart = echarts.init(dom, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });

      const option = {
        backgroundColor: '',
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['07.26', '07.27', '07.28', '07.29', '07.30', '07.31', '08.01'],
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize : 15      //更改坐标轴文字大小
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '单位: 人',

        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            symbol: 'emptyCircle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            itemStyle: {
              // 设置symbol的颜色
              normal: {
                color: '#EE6666'
              }
            },
            areaStyle: {//区域填充渐变颜色
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(215, 89, 25, 1)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(157, 102, 79, 1)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            smooth: true
          },
        ],
        grid:{ // 让图表占满容器
          top:"35",
          left:"30",
          right:"20",
          bottom:"20"
        }
      };

      if (option && typeof option === 'object') {
        this.myChart.setOption(option);
      }
    },
  },
  mounted() {
    this.renderChart()
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 180px;
  flex-wrap: nowrap;
  .coreTitle {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
  .up {
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;
    .titleDiv {
      width: 100%;
      align-items: center;
      display: flex;
      .tileSize {
        //color: rgb(0, 186, 255);
        font-size: 15px;
        text-align: center;
        width:90%;
        height: 20px;
        line-height: 20px;
        margin: 0 auto
      }
    }
    .item {
      border-radius: 6px;
      height: 47px;
      .dv-dig-flop {
        width: 100%;
        font-size: 24px;
        text-align: center;
        height: 27px;
        line-height: 27px;
        color: #3ce4c8;
      }

    }
  }
  .down {
    width: 70%;
  }
}
</style>
